import { cleanClass } from '@shared/utils/cleanClass.js';

const PageWrapper = ({ children = null, header, name = '', variant = '' }) => {
  return (
    <div className={cleanClass(`comp-page-wrapper ${name} ${variant || ''}`)}>
      <div className="main-column">
        {header}
        <div className="content">{children}</div>
      </div>
    </div>
  );
};

export default PageWrapper;
